// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __assign } from "tslib";
import { Amplify, ConsoleLogger as Logger } from '@aws-amplify/core';
import InAppMessaging from './InAppMessaging';
var logger = new Logger('Notifications');
var NotificationsClass = /** @class */ (function () {
    function NotificationsClass() {
        var _this = this;
        this.config = {};
        /**
         * Configure Notifications
         * @param {Object} config - Notifications configuration object
         */
        this.configure = function (_a) {
            var config = (_a === void 0 ? {} : _a).Notifications;
            _this.config = __assign(__assign({}, _this.config), config);
            logger.debug('configure Notifications', config);
            // Configure sub-categories
            _this.inAppMessaging.configure(_this.config.InAppMessaging);
            return _this.config;
        };
        this.inAppMessaging = new InAppMessaging();
    }
    /**
     * Get the name of the module category
     * @returns {string} name of the module category
     */
    NotificationsClass.prototype.getModuleName = function () {
        return 'Notifications';
    };
    Object.defineProperty(NotificationsClass.prototype, "InAppMessaging", {
        get: function () {
            return this.inAppMessaging;
        },
        enumerable: true,
        configurable: true
    });
    return NotificationsClass;
}());
var Notifications = new NotificationsClass();
export default Notifications;
Amplify.register(Notifications);
//# sourceMappingURL=Notifications.js.map